export default "__VITE_ASSET__62ad22a0__"